/* Floorboards V5 experiments: presentation layer only; checkout and enquiry stay in V4. */
(() => {
  'use strict';

  function initV5() {
    const experience = document.querySelector('[data-rf-v5-experience]');
    const product = document.querySelector('product-info.rf-floorboards-v4');
    if (!experience || !product || product.dataset.rfV5Ready === '1') return;

    const grid = product.querySelector('[data-rf-v4-grid]');
    if (!grid) return;
    product.dataset.rfV5Ready = '1';
    // Liquid renders the finished workflow with its final styles on first paint.
    // Do not move controls or trigger layout recalculation after load.
    const isAB = experience.dataset.rfV5Style === 'a' || experience.dataset.rfV5Style === 'b';
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollTo = target => target?.scrollIntoView({
      behavior: reduceMotion() ? 'auto' : 'smooth',
      block: 'start'
    });

    experience.querySelectorAll('[data-rf-v5-jump]').forEach(button => {
      button.addEventListener('click', () => {
        if (button.dataset.rfV5Jump === 'colours') {
          product.querySelector('[data-rf-v4-mode-tab="enquiry"]')?.click();
        }
        if (button.dataset.rfV5Jump === 'sample') {
          const sample = product.querySelector('[data-rf-v4-mode-tab="sample"]');
          if (sample) {
            document.body.classList.remove('rf-v5-show-enquiry');
            sample.click();
          }
        }
        scrollTo(grid);
      });
    });

    if (isAB) return;

    if (experience.dataset.rfV5Style !== 'c') return;

    // Material Studio: the big image remains a room photo. Swatches update the
    // smaller close-up and select the corresponding V4 enquiry/sample colour.
    const buttons = [...experience.querySelectorAll('[data-rf-v5-colour]')];
    const detail = experience.querySelector('.rf-v5__visual-second .rf-v5__material-photo');
    const selectedLabel = experience.querySelector('[data-rf-v5-selected-colour]');
    const cards = [...product.querySelectorAll('[data-rf-v4-card]')];
    const findCard = name => cards.find(card => card.dataset.colour === name);
    let materialImageRequest = 0;

    function showMaterial(name, imageUrl, isCover = false) {
      if (!name) return;
      const matching = isCover ? null : buttons.find(button => button.dataset.rfV5Colour === name);
      const url = isCover ? imageUrl : matching?.dataset.rfV5Image || imageUrl
        || findCard(name)?.querySelector('[data-rf-v4-preview]')?.dataset.imageMain;

      // Load before swapping so changing a finish never blanks the detail.
      if (detail && url && detail.getAttribute('src') !== url) {
        const request = ++materialImageRequest;
        const preloader = new Image();
        preloader.onload = () => {
          if (request !== materialImageRequest || !detail.isConnected) return;
          detail.removeAttribute('srcset');
          detail.src = url;
          detail.alt = isCover ? 'Product cover photo' : name + ' flooring material close-up';
        };
        preloader.src = url;
      }
      if (selectedLabel) selectedLabel.textContent = isCover ? 'Product cover' : name;
      buttons.forEach(button => {
        const active = !isCover && button.dataset.rfV5Colour === name;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    experience.addEventListener('click', event => {
      const button = event.target.closest('[data-rf-v5-colour]');
      if (!button || !experience.contains(button)) return;

      const name = button.dataset.rfV5Colour;
      const card = findCard(name);
      if (!card) return;
      const mode = product.dataset.rfV4Mode || 'enquiry';
      const input = card.querySelector(mode === 'enquiry'
        ? '[data-rf-v4-enquire-colour]'
        : '[data-rf-v4-purchase-colour]');

      // Keep multi-colour enquiries intact. In single-colour purchase/sample
      // modes, let V4's radio/variant sync remain the source of truth.
      if (input && !input.disabled && !input.checked) input.click();
      showMaterial(name, button.dataset.rfV5Image);
    });

    product.addEventListener('click', event => {
      const cover = event.target.closest('[data-rf-v5-cover-trigger], [data-rf-v4-cover]');
      if (cover && product.contains(cover)) {
        showMaterial('Product cover', cover.dataset.imageMain, true);
        scrollTo(experience.querySelector('.rf-v5__visual'));
        return;
      }
      const preview = event.target.closest('[data-rf-v4-preview]');
      if (preview && product.contains(preview)) {
        showMaterial(preview.dataset.colour, preview.dataset.imageMain);
      }
    });

    product.addEventListener('change', event => {
      const input = event.target;
      if (input.matches('[data-rf-v4-enquire-colour], [data-rf-v4-purchase-colour]') && input.checked) {
        showMaterial(input.value);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV5, { once: true });
  } else {
    initV5();
  }
  document.addEventListener('shopify:section:load', initV5);
})();
